// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'layers';

export const Component = () => (
  <path d='m2.54 8.406 9.72-3.496 9.723 3.496-9.722 3.496-9.722-3.496Zm21.982 0L12.26 4 0 8.406l12.26 4.406 12.262-4.406Zm-4.071 2.442-1.293.48 2.826 1.005-9.722 3.496-9.722-3.496 2.826-1.006-1.293-.479-4.071 1.485 12.26 4.406 12.261-4.406-4.07-1.485h-.002Zm0 3.928-1.293.479 2.826 1.005-9.722 3.496L2.54 16.26l2.826-1.005-1.293-.48L.002 16.26l12.26 4.406 12.261-4.406-4.07-1.484h-.002Z' />
);

export const viewBox = '0 0 25 25';
